var map = {
	"./aboriginalflag.svg": 223,
	"./care.svg": 224,
	"./child.svg": 225,
	"./headbrain.svg": 226,
	"./medal.svg": 227,
	"./medication.svg": 228,
	"./nucleo-logo.svg": 229,
	"./pill.svg": 230,
	"./rainbow.svg": 231,
	"./skincheck.svg": 232,
	"./stethoscope.svg": 233,
	"./travel.svg": 234,
	"./vaccine.svg": 235,
	"./worker.svg": 236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;